var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 56,
    viewBox: "0 0 65 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.772 41.6985C63.2602 40.4162 61.8059 39.7916 60.5237 40.3035C59.2414 40.8154 58.6168 42.2696 59.1287 43.5519C59.7794 45.1823 59.566 47.0438 58.5578 48.5318C57.549 50.0205 55.9339 50.8744 54.1267 50.8744H10.8836C8.91219 50.8744 7.16156 49.8458 6.20043 48.1225C5.2378 46.3964 5.28305 44.3622 6.32143 42.6809L27.943 7.67417C28.9275 6.08017 30.6329 5.12854 32.5051 5.12854C34.3774 5.12854 36.0826 6.08017 37.0672 7.67417L53.0582 33.5647C53.7837 34.7394 55.3242 35.1037 56.4985 34.3778C57.673 33.6525 58.0373 32.1121 57.3117 30.9375L41.3206 5.04692C39.4186 1.96741 36.1231 0.128906 32.505 0.128906C28.8869 0.128906 25.5913 1.96753 23.6893 5.04692L2.0678 40.0537C0.0632947 43.2995 -0.0239555 47.2263 1.83417 50.5579C3.6908 53.8866 7.07368 55.8739 10.8836 55.8739H54.1267C57.6189 55.8739 60.7425 54.2198 62.6967 51.336C64.6362 48.4738 65.038 44.8709 63.772 41.6985Z",
    fill: "#1369BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5063 45.9995C33.8869 45.9995 35.006 44.8804 35.006 43.4998C35.006 42.1191 33.8869 41 32.5063 41H32.505C31.1244 41 30.0059 42.1191 30.0059 43.4998C30.0059 44.8804 31.1256 45.9995 32.5063 45.9995Z",
    fill: "#1369BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0054 34.752V16.3787C35.0054 14.998 33.8863 13.8789 32.5056 13.8789C31.125 13.8789 30.0059 14.998 30.0059 16.3787V34.752C30.0059 36.1327 31.125 37.2518 32.5056 37.2518C33.8863 37.2518 35.0054 36.1327 35.0054 34.752Z",
    fill: "#1369BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.5624e743a409e8e5d08f287a902e5f46.svg";
export { ForwardRef as ReactComponent };